// Mock data for Sarvshakti website

export const heroData = {
  title: "Empowering Financial Growth",
  subtitle: "Your Trusted Partner in Investment Management & Merchant Banking",
  description: "Leading SEBI registered financial services with expertise in AIF management, IPO advisory, and capital market solutions.",
  cta: {
    primary: "Get Started",
    secondary: "Learn More"
  }
};

export const companiesData = [
  {
    id: 1,
    name: "Sarvshakti Financial Advisors Private Limited",
    type: "Investment Manager",
    description: "Investment Manager of Fortune Hands Growth Fund, a SEBI registered Alternative Investment Fund (AIF) Category II. We specialize in identifying high-growth opportunities and delivering superior risk-adjusted returns.",
    registration: "SEBI Registered AIF Category II",
    services: ["Fund Management", "Portfolio Advisory", "Risk Management", "Investment Strategy"],
    link: "https://fortunehand.com"
  },
  {
    id: 2,
    name: "Sarvshakti Capital Venture Limited",
    type: "Merchant Banking",
    description: "Providing comprehensive merchant banking services including IPO advisory, corporate restructuring, and capital raising solutions. Currently in process of obtaining SEBI Category II Merchant Banking license.",
    registration: "SEBI Registration In Process (Category II)",
    services: ["IPO Advisory", "Fund Raising", "Corporate Finance", "M&A Advisory"],
    link: null
  }
];

export const servicesData = [
  {
    id: 1,
    title: "IPO Advisory",
    description: "End-to-end IPO advisory services including structuring, documentation, regulatory compliance, and listing support.",
    icon: "TrendingUp"
  },
  {
    id: 2,
    title: "Fund Management",
    description: "Professional management of Alternative Investment Funds with focus on growth and value creation.",
    icon: "PieChart"
  },
  {
    id: 3,
    title: "Fund Raising",
    description: "Strategic capital raising solutions for businesses across various stages of growth.",
    icon: "Wallet"
  },
  {
    id: 4,
    title: "Merchant Banking",
    description: "Comprehensive merchant banking services including underwriting, placement, and advisory.",
    icon: "Building2"
  },
  {
    id: 5,
    title: "Portfolio Advisory",
    description: "Customized portfolio management and investment advisory services for institutional clients.",
    icon: "LineChart"
  },
  {
    id: 6,
    title: "Corporate Finance",
    description: "Strategic financial advisory for mergers, acquisitions, and corporate restructuring.",
    icon: "Briefcase"
  }
];

export const philosophyData = {
  title: "Our Investment Philosophy",
  subtitle: "Built on principles of integrity, research, and sustainable growth",
  principles: [
    {
      id: 1,
      title: "Research-Driven Approach",
      description: "Deep fundamental analysis and comprehensive due diligence form the foundation of every investment decision.",
      icon: "Search"
    },
    {
      id: 2,
      title: "Risk-Adjusted Returns",
      description: "Focus on generating superior returns while maintaining optimal risk management frameworks.",
      icon: "Shield"
    },
    {
      id: 3,
      title: "Long-Term Value Creation",
      description: "Investment strategies designed for sustainable wealth creation and long-term partnership.",
      icon: "Target"
    },
    {
      id: 4,
      title: "Regulatory Excellence",
      description: "Unwavering commitment to regulatory compliance and highest governance standards.",
      icon: "Award"
    }
  ]
};

export const portfolioData = {
  title: "Track Record of Excellence",
  subtitle: "Delivering consistent performance across market cycles",
  stats: [
    {
      id: 1,
      value: "₹500+ Cr",
      label: "Assets Under Management",
      icon: "TrendingUp"
    },
    {
      id: 2,
      value: "15+",
      label: "Successful IPO Mandates",
      icon: "FileCheck"
    },
    {
      id: 3,
      value: "100+",
      label: "Corporate Clients",
      icon: "Users"
    },
    {
      id: 4,
      value: "20+",
      label: "Years Combined Experience",
      icon: "Award"
    }
  ],
  caseStudies: [
    {
      id: 1,
      title: "Growth Fund Performance",
      description: "Fortune Hands Growth Fund has consistently outperformed benchmark indices with strategic sector allocation and active portfolio management.",
      category: "Fund Management",
      result: "Superior risk-adjusted returns"
    },
    {
      id: 2,
      title: "Successful IPO Launch",
      description: "Led end-to-end IPO advisory for a mid-cap technology firm, achieving 120% subscription and successful listing.",
      category: "IPO Advisory",
      result: "Oversubscribed by 1.2x"
    },
    {
      id: 3,
      title: "Strategic Capital Raise",
      description: "Facilitated ₹50 Cr private equity round for a high-growth manufacturing company with favorable valuation.",
      category: "Fund Raising",
      result: "₹50 Cr raised successfully"
    }
  ]
};

export const teamData = [
  {
    id: 1,
    name: "CA Pawan kumar Garg",
    designation: "Managing Director",
    bio: "Leading the strategic vision and investment decisions with deep expertise in identifying high-growth opportunities across sectors.",
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400",
    linkedin: "https://www.linkedin.com/in/pawan-kumar-garg-b7976412/"
  },
  {
    id: 2,
    name: "CA Hitesh Goyal",
    designation: "Executive Director",
    bio: "Bringing analytical rigor and market insights to investment evaluations, ensuring disciplined capital allocation.",
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400",
    linkedin: "https://www.linkedin.com/in/aayush-bansal-1661b8190?originalSubdomain=in"
  },
  {
    id: 3,
    name: "Aayush Bansal",
    designation: "Whole Time Director",
    bio: "A member of the key investment team supporting sourcing, diligence coordination, transaction execution and portfolio monitoring.",
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400",
    linkedin: "https://www.linkedin.com/in/aayush-bansal-1661b8190?originalSubdomain=in"
  }
];

export const insightsData = [
  {
    id: 1,
    title: "Market Outlook 2025: Opportunities in Mid-Cap Segment",
    excerpt: "Analysis of emerging opportunities in the mid-cap space with favorable valuations and growth potential.",
    category: "Market Insights",
    date: "December 15, 2024",
    readTime: "5 min read",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400"
  },
  {
    id: 2,
    title: "IPO Market Trends: What Companies Need to Know",
    excerpt: "Key considerations for companies planning to go public in the current regulatory environment.",
    category: "IPO Advisory",
    date: "December 10, 2024",
    readTime: "7 min read",
    image: "https://images.unsplash.com/photo-1590283603385-17ffb3a7f29f?w=400"
  },
  {
    id: 3,
    title: "Alternative Investment Funds: A Growth Story",
    excerpt: "Understanding the AIF landscape in India and opportunities for sophisticated investors.",
    category: "Fund Management",
    date: "December 5, 2024",
    readTime: "6 min read",
    image: "https://images.pexels.com/photos/590011/pexels-photo-590011.jpeg?w=400"
  }
];

export const contactData = {
  title: "Get in Touch",
  subtitle: "Let's discuss how we can help you achieve your financial goals",
  email: "sarvshaktifin@gmail.com  info@sarvshakti.in",
  phone: "011 49076400",
  address: "901 D-MALL Netaji Subhash Place, Pitampura, New delhi - 110085"
};
